import styled from '@emotion/styled'
import { Button, Row } from 'antd'
import Col from 'antd/lib/col'

export const BackButton = styled(Button)`
  color: #4a4a68;
  border: 1px solid #4a4a68;

  &:hover {
    color: #4a4a68;
    border: 1px solid #4a4a68;
  }
`

export const TableHeaderTooltip = styled.div`
  display: flex;
  align-items: center;
  whitespace: nowrap;
`

export const TableCellNoWrap = styled.span`
  white-space: nowrap;
`

export const FormItemCol = styled(Col)`
  padding-right: 8px;
  &:not(:first-of-type) {
    padding-left: 0 !important;
  }
  & > .control {
    width: 100% !important;
  }
`

export const OverflowContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  margin: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CustomSorterRow = styled(Row)`
  min-width: max-content;
`

export const OrderStoreInfo = styled.div`
  > .name {
    font-weight: bold;
    color: #d092dd;
    margin-bottom: 4px;
  }

  > .zip {
    color: #4a4a68;
    margin-bottom: 0;
  }
`
